module.exports = __WEBPACK_EXTERNAL_MODULE_72__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"tui-date-picker","commonjs2":"tui-date-picker","amd":"tui-date-picker","root":["tui","DatePicker"]}
// module id = 72
// module chunks = 0